import type { MarketTypeFragment } from '@/core/oddsApi/oddsApiType';
import type { IMarket, IMarketPrice, IMarketSelection } from '@/interface/IMarket';
import { PriceStyle } from '@/interface/enum';

function resolveName(template: MarketTypeFragment['template']): string {
    return template.details.reduce((name, detail) => {
        if (detail.placeholder && detail.value) {
            const value = detail.value;
            return name.replaceAll(detail.placeholder, () => value);
        }
        return name;
    }, template.value);
}

function formatPrice(price: MarketTypeFragment['selections'][number]['price']): IMarketPrice {
    return {
        value: price.value,
        priceStyle: PriceStyle.fromOddsApi(price.oddsStyle),
    };
}

function formatSelection(selection: MarketTypeFragment['selections'][number]): IMarketSelection {
    return {
        id: selection.id,
        marketId: selection.marketId,
        matchId: selection.matchId,
        isSuspended: selection.isSuspended,
        selectionTypeId: selection.selectionTypeId,
        selectionOrder: selection.selectionOrder,
        name: resolveName(selection.template),
        price: formatPrice(selection.price),
    };
}

export function formatMarket(market: MarketTypeFragment): IMarket {
    return {
        id: market.id,
        matchId: market.matchId,
        marketTypeId: market.marketTypeId,
        isLive: market.isLive,
        isSingle: market.isSingle,
        isSuspended: market.isSuspended,
        isMixParlayAvailable: market.isMixParlayAvailable,
        matchStatTypeId: market.matchStatTypeId,
        displayPriority: market.displayPriority,
        name: resolveName(market.template),
        selections: market.selections.map(formatSelection),
    };
}
